import { useCopilotInstruction as e } from "./global-state.js";
import { Renderer as t } from "../node_modules/.pnpm/@openuidev_react-lang@0.1.5_react@19.2.7/node_modules/@openuidev/react-lang/dist/Renderer.js";
import "../node_modules/.pnpm/@openuidev_react-lang@0.1.5_react@19.2.7/node_modules/@openuidev/react-lang/dist/index.js";
import * as n from "react";
import { createContext as r, useContext as i, useEffect as a, useMemo as o, useRef as s, useState as c } from "react";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
import { Streamdown as f, useIsCodeFenceIncomplete as p } from "streamdown";
import { mermaid as m } from "@streamdown/mermaid";
//#region src/react/markdown.tsx
var h = r(null), g = r(null);
function _({ children: t, markdown: r, library: i, libraryPromptOptions: a, mermaidComponent: s }) {
	let c = o(() => {
		let { pre: e, code: t, ...a } = r ?? {}, o = { ...a }, s = e ?? S;
		o.pre = function({ children: e, ...t }) {
			let r = n.isValidElement(e) && typeof e.props.className == "string" ? e.props.className : "";
			return r === "language-openui" || r === "language-mermaid" ? /* @__PURE__ */ u(l, { children: e }) : /* @__PURE__ */ u(s, {
				...t,
				children: e
			});
		};
		let c = t ?? C;
		return o.code = function({ className: e, children: t, ...n }) {
			let r = typeof e == "string" ? e.replace("language-", "") : "", a = typeof t == "string" ? t : String(t ?? "");
			return r === "openui" && i != null ? /* @__PURE__ */ u(v, { code: a }) : r === "mermaid" ? /* @__PURE__ */ u(b, { code: a.replace(/\n$/, "") }) : /* @__PURE__ */ u(c, {
				...n,
				className: e,
				children: t
			});
		}, o;
	}, [r, i]), d = o(() => {
		let e = i == null ? null : i.prompt({
			...a,
			preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
		});
		return e == null ? "" : [
			"## Content Guidelines",
			"",
			"You can render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
			"",
			e
		].join("\n");
	}, [i, a]);
	e({
		instruction: d,
		isEnabled: d !== ""
	});
	let f = o(() => ({ components: c }), [c]);
	return /* @__PURE__ */ u(h.Provider, {
		value: f,
		children: /* @__PURE__ */ u(g.Provider, {
			value: i ?? null,
			children: /* @__PURE__ */ u(y.Provider, {
				value: s ?? null,
				children: t
			})
		})
	});
}
function v({ code: e }) {
	let n = i(g), r = p();
	return n == null || e.trim() === "" ? null : /* @__PURE__ */ u(t, {
		response: e.trim(),
		library: n,
		isStreaming: r
	});
}
var y = r(null);
function b({ code: e }) {
	let t = p(), [n, r] = c({ status: "idle" }), o = i(y), l = s(0);
	return a(() => {
		if (t) return;
		let n = !1, i = `mermaid-${++l.current}-${Date.now()}`;
		async function a() {
			try {
				let { svg: t } = await m.getMermaid().render(i, e);
				n || r({
					status: "ok",
					svg: t,
					code: e
				});
			} catch (t) {
				n || r({
					status: "error",
					message: t instanceof Error ? t.message : "Failed to render diagram",
					code: e
				});
			}
		}
		return a(), () => {
			n = !0;
		};
	}, [e, t]), o == null ? n.status === "error" ? /* @__PURE__ */ d("pre", {
		style: {
			color: "red",
			fontSize: "0.85em"
		},
		children: ["Mermaid Error: ", n.message]
	}) : n.status === "ok" ? /* @__PURE__ */ u("div", { dangerouslySetInnerHTML: { __html: n.svg } }) : null : /* @__PURE__ */ u(o, { result: n });
}
function x({ children: e, isAnimating: t = !1, animated: n, rehypePlugins: r }) {
	let a = i(h);
	if (a == null) throw Error("Markdown must be used within CopilotProvider");
	return /* @__PURE__ */ u(f, {
		components: a.components,
		animated: n,
		isAnimating: t,
		rehypePlugins: r,
		children: e
	});
}
function S(e) {
	return /* @__PURE__ */ u("pre", { ...e });
}
function C(e) {
	return /* @__PURE__ */ u("code", { ...e });
}
//#endregion
export { _ as CopilotProvider, x as Markdown };
